<template>
    <div class="border-gray-200 border-b">
        <div class="p-5 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">

            <template v-if="$root.loginReferral === 'SmsMessage'">
                <p class="mb-5 font-medium">
                    Please provide your e-mail address to receive receipts, reminders, or general notifications regarding your account.
                </p>

                <label for="email" class="block font-semibold text-gray-700">
                    Email
                </label>
                <input v-model="email"
                       type="text"
                       name="email"
                       id="email"
                       :class="[
                            `py-3 px-4 rounded bg-gray-50 relative block w-full rounded-md bg-transparent focus:z-10 sm:text-sm`,
                            this.emailError ? `border-red-400 border-2 focus:ring-red-400 focus:border-red-400` : `border-gray-300 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400`
                       ]"
                       placeholder="Your email">
                <span v-if="emailError" class="block text-xs text-red-500 mt-1" v-text="emailError" />
                <span v-else-if="emailError === false" class="block text-xs text-green-500 mt-1">That email address is valid.</span>
            </template>
            <template v-else-if="$root.loginReferral === 'Email'">
                <p class="mb-5 font-medium">
                    Please provide your mobile phone number to receive receipts, reminders, or general notifications regarding your account.
                </p>

                <label for="email" class="block font-semibold text-gray-700 mb-2">
                    Mobile Phone Number
                </label>
                <the-mask
                    :mask="'(F##) ###-####'"
                    v-model="phoneNumber"
                    :placeholder="'Your mobile phone number'"
                    :type="'tel'"
                    name="phone_number"
                    id="phone_number"
                    :tokens="hexTokens"
                    :class="`py-3 px-4 rounded bg-gray-50 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 relative block w-full rounded-md bg-transparent focus:z-10 sm:text-sm border-gray-300`"/>
                <span v-if="numberError" class="block text-xs text-red-500 mt-1" v-text="numberError" />
            </template>
            <template v-else-if="! $root.loginReferral || $root.loginReferral === 'Direct'">
                <p class="mb-5 font-medium">
                    Please provide your email address and mobile phone number to receive receipts, reminders, or general notifications regarding your account.
                </p>

                <label for="email" class="block font-semibold text-gray-700 mb-2">
                    Email
                </label>
                <input v-model="email"
                       type="text"
                       name="email"
                       id="email"
                       :class="[
                            `py-3 px-4 rounded bg-gray-50 relative block w-full rounded-md bg-transparent focus:z-10 sm:text-sm`,
                            this.emailError ? `border-red-400 border-2 focus:ring-red-400 focus:border-red-400` : `border-gray-300 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400`
                       ]"
                       placeholder="Your email">
                <span v-if="emailError" class="block text-xs text-red-500 mt-1" v-text="emailError" />
                <span v-else-if="emailError === false" class="block text-xs text-green-500 mt-1">That email address is valid.</span>

                <label for="email" class="block font-semibold text-gray-700 mt-4 mb-2">
                    Mobile Phone Number
                </label>
                <the-mask
                    :mask="'(F##) ###-####'"
                    v-model="phoneNumber"
                    :placeholder="'Your mobile phone number'"
                    :type="'tel'"
                    name="phone_number"
                    id="phone_number"
                    :tokens="hexTokens"
                    :class="`py-3 px-4 rounded bg-gray-50 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 relative block w-full rounded-md bg-transparent focus:z-10 sm:text-sm border-gray-300`"/>
                <span v-if="numberError" class="block text-xs text-red-500 mt-1" v-text="numberError" />
            </template>

            <template v-if="$root.$refs.app.settings.is_non_business_hours">
                <label class="flex items-center justify-center md:justify-start text-justify mt-4 text-xs">
                    <input type="checkbox" class="form-control ml-4 mr-6" :value="true" v-model="afterHours" />
                    By checking the box you are agreeing to have your payment receipt sent during non-business hours. If you do not check the box your payment receipt will be sent upon the next eligible business day.
                </label>
            </template>

            <template v-if="! sendStartMessage">
                <button type="button" id="gather-contact-continue-button"
                        @click="saveBoth"
                        :class="{
                            [`mt-4 mb-2 w-full justify-center text-black items-center inline-flex items-center px-3 text-lg pt-4 pb-3 border border-transparent shadow-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 bg-${$root.theme}-300 hover:bg-${$root.theme}-400 focus:ring-${$root.theme}-200`]: true,
                        }">
                    Continue to account summary
                </button>
            </template>
            <template v-else>
                You've opted out, you must send "START" to {{ sendStartMessage }} to re-subscribe.

                <button type="button"
                        @click="$emit('done')"
                        :class="`mt-4 mb-2 w-full justify-center text-black items-center inline-flex items-center px-3 text-lg pt-4 pb-3 border border-transparent shadow-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 bg-${$root.theme}-300 hover:bg-${$root.theme}-400 focus:ring-${$root.theme}-200`">
                    Done
                </button>
            </template>
        </div>
    </div>
</template>

<script>
    import validatesAndSavesContactInformation from "../mixins/validatesAndSavesContactInformation";

    export default {
        mixins: [validatesAndSavesContactInformation],

        props: ['account'],

        data() {
            return {
                afterHours: false,
                isDone: false,
                resetEmail: false,
            }
        },

        mounted() {
            this.email = this.account.email;

            this.$root.$refs.app.updatePageName('obtain-contact-information');

            if (this.$root.loginReferral === 'Email') {
                this.emailRequired = false;
            } else if (this.$root.loginReferral === 'SmsMessage') {
                this.numberRequired = false;
            }
        },

        methods: {
            done() {
                if (this.isDone) return;

                this.isDone = true;

                if (! this.$root.$refs.app.settings.is_non_business_hours) {
                    this.$http
                        .post(`${this.$root.$refs.app.consumerPortalBaseUrl}/api/payments/receipt`, { email: this.email })
                        .then(() => {
                            this.$emit('done');
                        });

                    return;
                }

                if (! this.afterHours) {
                    this.$emit('done');
                } else {
                    return this.$http
                        .post(`${this.$root.$refs.app.consumerPortalBaseUrl}/api/payments/receipt`, { email: this.email })
                        .then(() => {
                            this.$emit('done');
                        });
                }
            }
        }
    }
</script>
